import { Injectable } from '@angular/core';
import { HttpUtilService } from '@services/http-util.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataRetentionService {
  rules: RetentionRule[] = [];
  constructor(private http: HttpUtilService) {}

  getInstanceDataRetention() {
    return this.http
      .request('GET', '/api/institution/data-retention/rules', null, null, true)
      .pipe(
        map((res: any) => {
          console.log(res);
          this.rules = res.map((rule: any, index: number) => ({
            ...rule,
            isActive:
              rule.expirationDate > new Date().toISOString() &&
              rule.effectiveDate < new Date().toISOString() &&
              rule.disabled === false,
          }));
          return this.rules;
        })
      );
  }

  updateRetentionRule(rule: RetentionRule) {
    this.rules = this.rules.map(r => (r.id === rule.id ? rule : r));
    return this.http.request(
      'PUT',
      '/api/institution/data-retention/rules',
      rule,
      null,
      true
    );
  }

  addRetentionRule(rule: RetentionRule) {
    rule.id = this.rules.length;
    this.rules.push(rule);
    return this.http.request(
      'POST',
      '/api/institution/data-retention/rules',
      rule,
      null,
      true
    );
  }
  searchCourses(
    filterInput: string,
    pageNumber: number,
    perPage: number,
    sortBy: string,
    sortAsc: boolean,
    hasHold: boolean
  ) {
    return this.http.request(
      'GET',
      `/api/retention/courses?search=${filterInput}&page=${pageNumber}&perPage=${perPage}&sortBy=${sortBy}&sortAsc=${sortAsc}&academicHold=${hasHold}`,
      null,
      {},
      true,
      false,
      false
    );
  }
  getCourse(courseId: string) {
    return this.http.request(
      'GET',
      `/api/retention/courses/${courseId}`,
      null,
      {},
      true,
      false,
      false
    );
  }
  searchUsers(
    filterInput: string,
    pageNumber: number,
    perPage: number,
    sortBy: string,
    sortAsc: boolean,
    pendingRemoval: boolean,
    academicHold = false
  ) {
    return this.http
      .request(
        'GET',
        `/api/retention/students?search=${filterInput}&page=${pageNumber}&perPage=${perPage}&sortBy=${sortBy}&sortAsc=${sortAsc}&pendingDelete=${pendingRemoval}&academicHold=${academicHold}`,
        null,
        {},
        true,
        false,
        false
      )
      .pipe(
        map((res: any) => {
          res.listItems = res.listItems.map((student: any) => {
            student.json_data.enrollmentCount = student.enrollmentcount;
            return student;
          });
          return res;
        })
      );
  }
  getUser(userId: string) {
    return this.http.request(
      'GET',
      `/api/retention/students/${userId}`,
      null,
      {},
      true,
      false,
      false
    );
  }

  getStudentWithAcademicHolf() {
    return this.http.request(
      'GET',
      `/api/retention/students/academic-hold`,
      null,
      {},
      true,
      false,
      false
    );
  }

  setAcademicHold(type: string, id: string, academicHold: boolean) {
    return this.http.request(
      'POST',
      `/api/retention/${type}/${id}/academic-hold`,
      { state: academicHold },
      {},
      true,
      false,
      false
    );
  }

  restoreUser(userId: string) {
    return this.http.request(
      'PUT',
      `/api/retention/students/${userId}/restore`,
      null,
      {},
      true,
      false,
      false
    );
  }

  deleteUser(userId: string) {
    return this.http.request(
      'DELETE',
      `/api/retention/students/${userId}`,
      null,
      {},
      true,
      false,
      false
    );
  }
}

export interface RetentionRule {
  id?: number;
  description: string;
  createdAt?: string;
  updatedAt?: string;
  effectiveDate: string;
  expirationDate: string | null;
  retentionPeriod: number;
  retentionType: 'COURSE' | 'STUDENT';
  userId?: string;
  isActive?: boolean;
  disabled: boolean;
}
